<template>
  <div class="noti-container" v-click-outside="closeNoti">
    <div
        class="noti-trigger"
        :class="{ 'is-active': isOpen }"
        @click.stop="toggleNoti"
    >
      <i class="el-icon-bell bell-icon"></i>
      <span v-if="totalCountNotification > 0" class="badge-count">
        {{ totalCountNotification > 99 ? '99+' : totalCountNotification }}
      </span>
    </div>

    <transition name="dropdown-fade">
      <div v-if="isOpen" class="noti-panel" @click.stop>
        <div class="panel-header">
          <div class="header-content">
            <span class="title">Thông báo mới</span>
            <span class="dot"></span>
          </div>
          <span class="sub-title">{{ totalCountNotification }} mục cần xử lý</span>
        </div>

        <div class="panel-body custom-scrollbar">
          <template v-for="item in menuConfig">
            <div
                v-if="checkPermission([item.permission]) && showCountData(item.title) > 0"
                :key="item.key"
                class="noti-item"
                @click="handleItemClick(item)"
            >
              <div class="noti-item-inner">
                <div class="icon-box">
                  <i :class="item.icon"></i>
                </div>
                <div class="info-box">
                  <span class="item-name">{{ item.title }}</span>
                </div>
                <div class="count-pill">
                  {{ showCountData(item.title) }}
                </div>
              </div>
            </div>
          </template>

          <div v-if="totalCountNotification === 0" class="empty-state">
            <div class="empty-icon">
              <i class="el-icon-message-solid"></i>
            </div>
            <p>Hiện tại không có thông báo mới</p>
          </div>
        </div>

<!--        <div class="panel-footer" v-if="totalCountNotification > 0">-->
<!--          <span>Xem tất cả</span>-->
<!--        </div>-->
      </div>
    </transition>
  </div>
</template>

<script>
import checkPermission from "@/utils/permission";
import { mapState } from "vuex";

export default {
  name: "NotificationNavbar",
  directives: {
    'click-outside': {
      bind(el, binding) {
        el.clickOutsideEvent = (event) => {
          if (!(el === event.target || el.contains(event.target))) {
            binding.value(event);
          }
        };
        document.body.addEventListener('click', el.clickOutsideEvent);
      },
      unbind(el) {
        document.body.removeEventListener('click', el.clickOutsideEvent);
      },
    },
  },
  data() {
    return {
      isOpen: false,
      intervalId: null,
      menuConfig: [
        { title: "Phụ huynh góp ý", key: "appsend-parent-feedback", url: "/appsend/parent-feedback", permission: "news_feedbackParent", icon: "el-icon-chat-dot-round", menuIdx: "2", subIdx: "2-3" },
        { title: "Giáo viên góp ý", key: "appsend-teacher-feedback", url: "/appsend/teacher-feedback", permission: "news_feedbackTeacher", icon: "el-icon-chat-line", menuIdx: "2", subIdx: "2-4" },
        { title: "Lời nhắn", key: "parentdiary-message-parent", url: "/parentdiary/message-parent", permission: "parentDiary_message", icon: "el-icon-chat-square", menuIdx: "3", subIdx: "3-1" },
        { title: "Dặn thuốc", key: "parentdiary-medicine", url: "/parentdiary/medicine", permission: "parentDiary_medicine", icon: "el-icon-first-aid-kit", menuIdx: "3", subIdx: "3-2" },
        { title: "Xin nghỉ", key: "parentdiary-take-leave", url: "/parentdiary/take-leave", permission: "parentDiary_absenLetter", icon: "el-icon-date", menuIdx: "3", subIdx: "3-3" },
        { title: "Nhận xét", key: "student-quality-evaluate", url: "/student-quality/evaluate", permission: "studentQuality_evaluate", icon: "el-icon-edit-outline", menuIdx: "6", subIdx: "6-2" },
        { title: "Album ảnh", key: "student-quality-album", url: "/student-quality/album", permission: "studentQuality_ablum", icon: "el-icon-picture-outline", menuIdx: "6", subIdx: "6-3" },
        { title: "Thu học phí", key: "finance-manage-v3-student-invoices", url: "/finance/manage-v3/student-invoices", permission: "tuition_v4", icon: "el-icon-bank-card", menuIdx: "20", subIdx: "20-1" },
        { title: "Thu học phí theo lớp", key: "finance-fees-order-excel", url: "/finance/v2", permission: "fees_2_excel", icon: "el-icon-bank-card", menuIdx: "8", subIdx: "8-7" },
        { title: "Thu học phí theo nhóm", key: "finance-fees-order-excel-group", url: "/finance/tuition-group-by-excel", permission: "fees_2_group", icon: "el-icon-money", menuIdx: "8", subIdx: "8-8" },
        { title: "Bảng lương", key: "finance-employee-salary-new", url: "/finance/employee/salary/new", permission: "salary_new_excel", icon: "el-icon-wallet", menuIdx: "9", subIdx: "9-5" },
        { title: "Xin nghỉ nhân sự", key: "finace-salary-absent", url: "/finace/salary/absent", permission: "attendanceEmployee_absentTeacher", icon: "el-icon-user", menuIdx: "10", subIdx: "10-1" },
        { title: "Quản lý phiếu chi", key: "finace-cashinternal-paymoney", url: "/finace/salary/absent", permission: "cashInternal_out", icon: "el-icon-upload2", menuIdx: "11", subIdx: "11-1" },
        { title: "Quản lý phiếu thu", key: "finace-cashinternal-collectmoney", url: "/finace/cashinternal/collectmoney", permission: "cashInternal_in", icon: "el-icon-download", menuIdx: "11", subIdx: "11-2" },
        { title: "Sinh nhật học sinh", key: "birthday-kids", url: "/birthday/kids", permission: "birthday_kids", icon: "el-icon-present", menuIdx: "13", subIdx: "13-1" },
        { title: "Sinh nhật phụ huynh", key: "birthday-parent", url: "/birthday/parent", permission: "birthday_parent", icon: "el-icon-sugar", menuIdx: "13", subIdx: "13-2" },
        { title: "Sinh nhật nhân viên", key: "birthday-employee", url: "/birthday/employee", permission: "birthday_teacher", icon: "el-icon-medal", menuIdx: "13", subIdx: "13-3" },
        { title: "Lịch sử nhắn tin SMS", key: "notifihis-historysms", url: "/notifihis/historysms", permission: "notifyHistory_historySms", icon: "el-icon-message", menuIdx: "14", subIdx: "14-3" },
        { title: "Lịch sử thông báo App", key: "notifihis-historyapp", url: "/notifihis/historyapp", permission: "notifyHistory_historyApp", icon: "el-icon-mobile-phone", menuIdx: "14", subIdx: "14-4" },
      ],
    }
  },
  computed: {
    ...mapState("notificationNavbarStore", ["listNotificationNavbar", "totalCountNotification"]),
  },
  methods: {
    checkPermission,
    toggleNoti() { this.isOpen = !this.isOpen; },
    closeNoti() { this.isOpen = false; },
    fetchNotification() { this.$store.dispatch("notificationNavbarStore/fetchNotification") },
    showCountData(title) {
      const data = this.listNotificationNavbar;
      if (data && data.length > 0) {
        const item = data.find(x => x.nameIcon === title);
        return item ? item.totalDetailIcon : 0;
      }
      return 0;
    },
    handleItemClick(item) {
      this.isOpen = false;
      // Logic điều hướng gốc
      sessionStorage.setItem("breadcrumbList", JSON.stringify([{ url: item.url, name: item.title }]));
      this.$store.dispatch("layout/setBreadcrumbActions", [{ url: item.url, name: item.title }]);
      this.$store.dispatch("notificationNavbarStore/handleActiveSubmenu", {
        menuIndex: item.menuIdx,
        menuItemIndex: item.subIdx
      });
      this.$router.push(item.url).catch(() => {});
    }
  },
  mounted() {
    this.fetchNotification();
    this.intervalId = setInterval(() => { this.fetchNotification(); }, 300000);
  },
  beforeDestroy() {
    if (this.intervalId) clearInterval(this.intervalId);
  }
}
</script>

<style lang="scss" scoped>
.noti-container {
  position: relative;
  display: inline-flex;
  align-items: center;
}

/* TRIGGER CHUÔNG */
.noti-trigger {
  width: 38px;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 10px;
  position: relative;
  transition: all 0.2s ease;
  background: transparent;

  &:hover, &.is-active {
    background: #f0f7ff;
    .bell-icon { color: #409eff; }
  }

  .bell-icon {
    font-size: 20px;
    color: #6a7ea8;
    transition: color 0.2s;
  }

  .badge-count {
    position: absolute;
    top: 4px;
    right: 4px;
    background: #f56c6c;
    color: #fff;
    font-size: 9px;
    font-weight: 700;
    min-width: 15px;
    height: 15px;
    line-height: 15px;
    text-align: center;
    border-radius: 10px;
    border: 1.5px solid #fff;
    box-shadow: 0 2px 4px rgba(245, 108, 108, 0.2);
  }
}

/* PANEL THÔNG BÁO */
.noti-panel {
  position: absolute;
  top: 48px;
  right: 0;
  width: 310px;
  background: #ffffff;
  border-radius: 14px;
  box-shadow: 0 15px 45px rgba(0, 0, 0, 0.1);
  z-index: 3000;
  border: 1px solid #f1f3f6;
  overflow: hidden;
}

.panel-header {
  padding: 15px 18px;
  border-bottom: 1px solid #f5f7fa;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .header-content {
    display: flex;
    align-items: center;
    gap: 8px;
    .title { font-weight: 700; font-size: 14px; color: #2c3e50; }
    .dot { width: 6px; height: 6px; background: #409eff; border-radius: 50%; }
  }
  .sub-title { font-size: 11px; color: #909399; }
}

.panel-body {
  max-height: 380px;
  overflow-y: auto;
  padding: 6px 0;

  .noti-item {
    padding: 0 10px;
    margin: 2px 0;

    .noti-item-inner {
      display: flex;
      align-items: center;
      padding: 10px;
      border-radius: 10px;
      cursor: pointer;
      transition: all 0.15s ease;

      &:hover {
        background-color: #f8fbff;
        .icon-box { background: #fff; }
        .item-name { color: #409eff; }
      }
    }

    .icon-box {
      width: 34px;
      height: 34px;
      background: #f2f6fc;
      border-radius: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 12px;
      i { color: #6a7ea8; font-size: 16px; }
    }

    .info-box {
      flex: 1;
      display: flex;
      flex-direction: column;
      .item-name { font-size: 13px; font-weight: 600; color: #4b5a6d; transition: color 0.15s; }
      .item-hint { font-size: 11px; color: #aeb9cc; margin-top: 1px; }
    }

    .count-pill {
      background: #fff1f0;
      color: #f5222d;
      font-size: 10.5px;
      font-weight: 700;
      padding: 1px 7px;
      border-radius: 20px;
    }
  }
}

.panel-footer {
  padding: 10px;
  text-align: center;
  background: #fafbfc;
  border-top: 1px solid #f5f7fa;
  span { font-size: 12px; color: #409eff; font-weight: 600; cursor: pointer; &:hover { text-decoration: underline; } }
}

.empty-state {
  padding: 40px 0;
  text-align: center;
  .empty-icon {
    width: 46px; height: 46px; background: #f5f7fa; border-radius: 50%;
    margin: 0 auto 10px; display: flex; align-items: center; justify-content: center;
    i { font-size: 22px; color: #dcdfe6; }
  }
  p { font-size: 12px; color: #909399; margin: 0; }
}

/* Animations mượt */
.dropdown-fade-enter-active, .dropdown-fade-leave-active { transition: all 0.25s ease; }
.dropdown-fade-enter, .dropdown-fade-leave-to { opacity: 0; transform: translateY(10px); }

.custom-scrollbar::-webkit-scrollbar { width: 4px; }
.custom-scrollbar::-webkit-scrollbar-thumb { background: #e4e7ed; border-radius: 10px; }
</style>
